import {useState, useEffect} from 'react';
import fetchData, {dataToBlob, fileDownload} from '../../utils/fetchData';
import config from "../../config/apiService.json";
import downloadFileType from "../../config/downloadFileType.json";

const useActRuleOrders = () => {
    const [data, setData] = useState([]);
    const [activePage, setActivePage] = useState(0);
    const [isLoading, setLoading] = useState(false);
    const [pdfFile, setPdfFile] = useState(null);
    const [hasMore, setHasMore] = useState(true);
    const pageSize = 10;
    const {actRuleOrders: actRuleOrdersApiEndPoint} = config;

    const getData = async () => {
        try {
            const response = await fetchData(`${actRuleOrdersApiEndPoint}?currentPage=${activePage}&recordPerPage=${pageSize}`);

            const { actRuleOrders } = response;

            if (!actRuleOrders || actRuleOrders.length === 0) {
                setHasMore(false); // No more data to fetch
                return;
            }

            // Update state with new data and increment the active page
            setData((prevData) => [...prevData, ...actRuleOrders]);
            setActivePage((prevPage) => prevPage + 1);
        } catch (error) {
            console.error("Error fetching data:", error);
            setHasMore(false); // Stop further loading on error
        }
    };

    const handleDownload = (fileName) => {
        fileDownload(fileName, downloadFileType.ACTRULEORDER);
    };

    const handleShowPdf = async (fileName) => {
        setLoading(true);
        const data = await dataToBlob(fileName, downloadFileType.ACTRULEORDER);
        setPdfFile(data);
    };

    useEffect(() => {
        getData();
    }, []);

    return {data, getData, hasMore, pdfFile, isLoading, setLoading, handleDownload, handleShowPdf, setPdfFile};
};

export default useActRuleOrders;
